import { render } from "./Index.vue?vue&type=template&id=41b2430c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=41b2430c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41b2430c"

export default script